export enum TYPES_SERVICES {
    MENTORING = 'MENTORING',
    LEADERSHIP = 'LEADERSHIP',
    TOOL_BOX = 'TOOL_BOX',
    BLOG = 'BLOG',
    OTHER = 'OTHER',
}
